<template>
  <div>
    <modal
      name="gestionar"

      :draggable="false"
      width="800"
      height="auto"
      :reset="true"
    >
      <br />
      <div>
        <div>
          <div class="modal-header" style="padding-right:5px; padding-top:0">
            <div class="row">
              <div class="col-md-1">
                <i class="ti-settings text-success" style="font-size:47px"></i>
              </div>
              <div class="col-md-7">
                <p class="titulo-modal">GESTIONAR PERMISOS</p>
                <p class="texto-pequeno" v-if="rolActivo!=''">Gestionar permisos para el rol <strong>{{rolActivo.nombre.toUpperCase()}}</strong></p>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="scroll">
              <div class="row">
                <div class="col-md-12">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>
                          Modulo
                        </th>
                        <th>
                          Submodulo
                        </th>
                        <th>
                          Acceso?
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(permiso,index) in permisosRolVar" :key="index">
                        <td>
                          {{permiso.modulo}}
                        </td>
                        <td>
                          {{permiso.name}}
                        </td>
                        <td>
                          <select v-model="permisosRolVar[index].estado" class="select-sm from-control" :value="permiso.estado" @change="update(permiso)">
                            <option :value="1">Si</option>
                            <option :value="0">No</option>
                          </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>  
          </div>
          <div class="modal-footer" style="padding-bottom:0">
            <!-- <center> -->

            <button
              type="button"
              class="btn btn-danger btn-block btn-icon btn-simple"
              @click="cerrarModal()"
            >
              <i class="fa fa-close"></i> CERRAR
            </button>
            <!-- </center> -->
          </div>
          <br />
        </div>
      </div>
    </modal>

    <div class="card">
      <div class="card-header">
        <center>
          <h4>Gestión de Roles Y Permisos</h4>
        </center>
      </div>
      <div class="card-content">
        <!-- <div class="row">
          <div class="col-md-4">
            <button class="btn btn-sm btn-success">
              <i class="fa fa-plus"></i> Nuevo Rol
            </button>
          </div>
        </div> -->
        <div class="row">
          <div class="col-md-7">
            <el-table
              class="table-striped"
              :data="queriedData"
              border
              style="width: 100%"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                else
              >
              </el-table-column>
              <el-table-column label="Estado" :minWidth="40">
                <template slot-scope="props">
                  <div v-if="props.row.estado == 1">
                    <span slot="title-label" class="label label-success">
                      <i class="ti-bell"></i> Activo
                    </span>
                  </div>
                  <div v-else>
                    <span slot="title-label" class="label label-danger">
                      <i class="ti-power-off"></i> Inactivo
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column fixed="right" :minWidth="40" label="Acciones">
                <template slot-scope="props">
                  <button
                    v-if="props.row.estado == 2"
                    class="btn btn-simple btn-info btn-icon check"
                    @click="activar(props.row)"
                  >
                    <i class="ti-check"></i>
                  </button>
                  <button
                    v-else
                    class="btn btn-simple btn-xs btn-warning btn-icon edit"
                    @click="desactivar(props.row)"
                  >
                    <i class="ti-close"></i>
                  </button>
                  <button class="btn btn-simple btn-xs btn-success" @click="abrirModal(props.row)">
                    <i class="fa fa-pencil"></i>
                  </button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-md-5">
            <div class="row">
              <form @submit.prevent="nuevoRol">
                <div class="col-md-12">
                  <small>Rol:</small>
                  <input type="text" class="form-control" v-model="nombre" required />
                </div>
                <div class="col-md-12">
                  <br />
                  <button
                    type="submit"
                    class="btn btn-success btn-block btn-sm"
                  >
                    <i class="fa fa-plus"></i> Nuevo Rol
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);

export default {
  data: () => ({
    rolActivo: [],
    permisosRolVar: [],



    nombre: '',
    ip: "https://avanti-erp.com/",
    tableColumns: [
      {
        prop: "nombre", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Nombre del rol", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 170, //ANCHO DE LA COLUMNA
      },
      //   {
      //     prop: "Estado", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
      //     label: "Estado", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
      //     // minWidth: 75 //ANCHO DE LA COLUMNA
      //   },
      //   {
      //     prop: "Acciones",
      //     label: "Acciones",
      //     // minWidth: 90
      //   },
    ],
    queriedData: [],
    type: ["", "info", "success", "warning", "danger"],
    notifications: {
      topCenter: false,
    },
  }),
  methods: {
    roles() {
      var token = localStorage.getItem("token");
      axios
        .request({
          method: "get",
          baseURL: this.ip + "api/roles",
          headers: {
            Authorization: "Bearer " + token, //utilizacion de la variable que contiene el token
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.queriedData = response.data.data;
          // console.log(this.roles);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    update(permiso){
      // console.log(permiso);
      const BASE_URL = `${this.ip}api/updatePermiso`;
      axios.put(BASE_URL, {
        id: permiso.id,
        estado: permiso.estado
      }).then(res =>{
        // console.log(res.data.mensaje);
        var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: ` <div style="padding: 3%;">
              <span><b> ${res.data.mensaje} </b>.</span>
              </div>
              `,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type["success"],
            });
        // alert(res.data.mensaje);
        // this.permisosRol(permiso.rol_id);
      }).catch(function (error) {
        console.log(error);
      })
    },
    abrirModal(rol){
      this.$modal.show("gestionar");
      // console.log(rol);
      this.rolActivo = rol;
      this.permisosRol(rol.id)
    },
    permisosRol(rol){
      const BASE_URL =`${this.ip}api/verPermisos/${rol}`;
      axios.get(BASE_URL).then(res =>{
        // console.log(res.data.data);
        this.permisosRolVar = res.data.data
      }).catch(err =>{
        console.log(err);
      });
    },
    cerrarModal(){
      this.$modal.hide("gestionar");
    },
    nuevoRol() {
      const BASE_URL = `${this.ip}api/roles/nuevo`;
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios.post(BASE_URL, {
          nombre: this.nombre
      }, config).then(res =>{
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: ` <div style="padding: 3%;">
              <span><b> ROL CREADO CON ÉXITO </b>.</span>
              </div>
              `,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type["success"],
            });
            // this.cargarUsuarios();
            this.roles();
            this.nombre = "";
      }).catch(error =>{
          console.log(err);
          this.roles();
      })
    },

    desactivar(rol = []) {
      // console.log(usuario);
      const BASE_URL = `${this.ip}api/roles/desactivar`;
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .put(
          BASE_URL,
          {
            id: rol.id,
          },
          config
        )
        .then(
          (res) => {
            // console.log(res);
            //   if ((res.data.status = true)) {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: ` <div style="padding: 3%;">
              <span><b> ROL INHABILITADO CON ÉXITO </b>.</span>
              </div>
              `,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type["success"],
            });
            // this.cargarUsuarios();
            this.roles();
          }
          // }
        )
        .catch((err) => {
          console.log(err);
          alert("Ocurrió un error, intentelo de nuevo");
        });
    },
    activar(rol = []) {
      //   console.log(rol);
      const BASE_URL = `${this.ip}api/roles/activar`;
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .put(
          BASE_URL,
          {
            id: rol.id,
          },
          config
        )
        .then(
          (res) => {
            // console.log(res);
            //   if ((res.data.status = true)) {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: ` <div style="padding: 3%;">
              <span><b> ROL HABILITADO CON ÉXITO </b>.</span>
              </div>
              `,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type["success"],
            });
            // this.cargarUsuarios();
            this.roles();
          }
          // }
        )
        .catch((err) => {
          console.log(err);
          alert("Ocurrió un error, intentelo de nuevo");
        });
    },
  },
  mounted() {
    this.roles();
  },
};
</script>

<style scoped>
 .scroll{
    width:100%;
    height:430px; 
    overflow:auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/Acceso/roles.vue